var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.bannerVisible)?_c('LfAppEnvironmentBanner',{attrs:{"environment":_vm.environment,"version":_vm.appVersion}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }